export const downloadableUrl = ( attachment ) => {
    if (attachment.length) {
        const finalAttachment = attachment[attachment.length - 1];
        const url = finalAttachment.url ;
        const splitUrl = url.split('upload');
        const downloadingurl = `${splitUrl[0]}upload/fl_attachment/${splitUrl[1]}`;
        return downloadingurl;
    }
};
